module.exports = __webpack_public_path__ + "img/Pomp.fbd69a18.png";